import React, { useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { setToLocalStorage } from '@/shared'
import styles from './ChooseRolePage.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { LoadingBlocker } from '@/components/Loader'
import { useTranslation } from 'react-i18next'
import { message } from 'antd'
import PreHeader from '@/components/home/components/PreHeader'
import Notice from '@pages/ChooseRole/Notice/Notice'
import { notificationsSelectors, notificationsThunks, userActions } from '@/entity'
import FlyingCircles from './FlyingCircles' // Ваш компонент с анимацией
import circlesData from './circles.json'
import { WhiteLogo } from '@app/images'
import { Button } from '@/ui'
import { employerProfileSelectors } from '@features/employerProfile/model'

export const ChooseRolePage = () => {
	const {
		t,
		i18n: { language, changeLanguage },
	} = useTranslation()
	const storedLanguage = localStorage.getItem('lang')

	const history = useHistory()
	const dispatch = useDispatch()
	const notification = useSelector(notificationsSelectors.notificationsAll)
	const activeCompany = useSelector(employerProfileSelectors.activeCompany)
	const profile = useSelector((state) => state.user.user)
	const error = useSelector((state) => state.auth.error)

	let employeeNotifs = notification?.employeeNotifs
	let employerNotifs = notification?.employerNotifs

	useEffect(() => {
		if (storedLanguage && storedLanguage !== language) {
			changeLanguage(storedLanguage)
		}
	}, [])

	useEffect(() => {
		if (error) {
			message.error(error.response ? error.response.data.message : error.message || 'Неизвестная ошибка')
		}
	}, [error])

	useEffect(() => {
		if (profile) {
			dispatch(notificationsThunks.getAll())
		}
	}, [profile])

	/*	const [enableModal, setEnableModal] = useState()
	useMemo(() => setEnableModal(process.env.REACT_APP_MODAL_INFO), [])
	const [isOpenInfo, setIsOpenInfo] = useState(true)
	useEffect(() => {
		if (enableModal === 'false') {
			setIsOpenInfo(false)
		}
	}, [enableModal])*/

	const onRedirect = (role) => {
		setToLocalStorage('activeRole', role)
		dispatch(userActions.setActiveRole(role))
		history.push(role === 'ROLE_EMPLOYER' ? '/employer' : '/worker')
	}

	const handleShowAllNotifications = (role) => {
		setToLocalStorage('activeRole', role)
		dispatch(userActions.setActiveRole(role))
	}

	const loading = !Boolean(profile)

	return (
		<>
			{/*раскомментировать в случае траура*/}
			{/*<PreHeader />*/}
			<div className={styles.container}>
				<div className={styles.logo}>
					<Link to={'/'}>
						<img className="logo" src={WhiteLogo} alt={'hr.enbek.kz'} />
					</Link>
				</div>
				<div className={styles.bgGradient}></div>
				<FlyingCircles circles={circlesData} />
				{!Boolean(profile) && !error && <LoadingBlocker />}
				<div className={styles.content}>
					{/*Закомментировано 20.06.2023*/}
					{/*раскомментировать в случае необходимости*/}
					{/*				{isOpenInfo && (
					<Notification
						handleProcess={setIsOpenInfo.bind(null, false)}
						handleCancel={setIsOpenInfo.bind(null, false)}
					/>
				)}*/}
					<div className={styles.left}>
						<div className={styles.buttonWrapper}>
							<p>{t('employer')}</p>
							<label>
								{language === 'rus'
									? activeCompany?.companyName ?? activeCompany?.companyNameKaz ?? ''
									: activeCompany?.companyNameKaz ?? activeCompany?.companyName ?? ''}
							</label>
							<Button buttondisable={loading ? 1 : 0} onClick={() => onRedirect('ROLE_EMPLOYER')}>
								{t('login_employer')}
							</Button>
							<div className={styles.noticeLink}>
								<Link
									to="/notifications"
									className={styles.showAllNotifications}
									onClick={() => handleShowAllNotifications('ROLE_EMPLOYER')}
								>
									{t('show_all_notifications')}
								</Link>
							</div>
						</div>
						{profile ? <Notice notify={employerNotifs} employer={true}></Notice> : null}
					</div>
					<div className={styles.right}>
						<div className={styles.buttonWrapper}>
							<p>{t('employee')}</p>
							<label>
								{(profile?.lastname || '') + ' ' + (profile?.firstname || '') + ' ' + (profile?.middlename || '')}
							</label>
							<Button buttondisable={loading ? 1 : 0} onClick={() => onRedirect('ROLE_EMPLOYEE')}>
								{t('login_employee')}
							</Button>
							<div className={styles.noticeLink}>
								<Link
									to="/notifications"
									className={styles.showAllNotifications}
									onClick={() => handleShowAllNotifications('ROLE_EMPLOYEE')}
								>
									{t('show_all_notifications')}
								</Link>
							</div>
						</div>
						{profile ? <Notice notify={employeeNotifs} employer={false}></Notice> : null}
					</div>
				</div>
			</div>
		</>
	)
}
